import React from 'react';
import sessionsdata from '../../utils/sessionsdata.json';
class Sessions extends React.Component {
  constructor() {
    super();
    this.state = {
      sessions: sessionsdata.sessions
    };
  }
  render() {
    let { sessions } = this.state;
    return (
      <section id="sessions" className="sessions- wrapper r-wrapper">
        <div>
          <p className="sessions-sec-heading r-fs-1">Sessions</p>
          <div className="sessions-cont">
            {sessions.map((session, idx) => (
              <div className="session-card" key={idx}>
                <div className="session-details">
                  <p className="session-completed">
                    {session.completed ? 'COMPLETED' : 'UPCOMING'}
                  </p>
                  <p className="session-time">{session.time}</p>
                </div>
                <a
                  className="session-title"
                  href={session.join}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {`${session.title.substring(0, 100)}...`}
                </a>
                <a
                  className="session-host"
                  href={session['host-contact']}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  hosted by {session.host}
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }
}

export default Sessions;
